export default __webpack_public_path__ + "alberta-recurring-activity.3cfc5be344a888f0cfa5.svg";